import * as XLSX from "xlsx";

import { ScenarioField } from "../types/field";
import type { Well } from "../views";

/**
 * Generates and downloads an Excel template file
 */
export const generateExcelTemplate = (wells: Well[], fields: ScenarioField[]): void => {
  const headers = ["Stick Name", ...fields.map((field) => field.name)];

  const data = wells.map((well) => {
    const row: Record<string, string> = { "Stick Name": well.uwid };
    fields.forEach((field) => {
      row[field.name] = "";
    });
    return row;
  });

  const ws = XLSX.utils.json_to_sheet(data, { header: headers });
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Well Survey Data");

  XLSX.writeFile(wb, "well_survey_template.xlsx");
};

/**
 * Parses an Excel file and returns data with headers
 */
export const parseExcelFile = (
  file: File
): Promise<{ data: Record<string, unknown>[]; headers: string[] }> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target?.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, {
          header: 1
        }) as unknown[][];

        const headers = jsonData[0] as string[];
        const rows = jsonData.slice(1).map((row) => {
          const obj: Record<string, unknown> = {};
          headers.forEach((header, index) => {
            obj[header] = (row as unknown[])[index];
          });
          return obj;
        });

        resolve({ data: rows, headers });
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = () => reject(new Error("Failed to read file"));
    reader.readAsArrayBuffer(file);
  });
};
